import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import FrontendFooter from "../../components/Layout/FrontendFooter";
import { Container, Typography, Box, Paper, Alert } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';

const DeleteAccount = () => {
  return (
    <div className="app-container">
      <Navigation />

      <section className="inner-banner text-white">
        <div className="home-container">
          <h1 className="page-title">Delete Account</h1>
          <p>Account deletion information</p>
        </div>
      </section>

      <section className="home-about">
        <Container maxWidth="lg">
          <Box sx={{ py: 6 }}>
            <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: "7px", backgroundColor: "white" }}>
              <Alert 
                severity="warning" 
                icon={<WarningIcon />}
                sx={{ mb: 3 }}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  Important Notice
                </Typography>
                <Typography variant="body1">
                  Account deletion is permanent and cannot be undone.
                </Typography>
              </Alert>

              <Typography variant="h4" gutterBottom sx={{ color: "#2c89e9", mb: 3 }}>
                How to Delete Your Account
              </Typography>

              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 3 }}>
                If you wish to delete your account, please follow these steps:
              </Typography>

              <Box component="ol" sx={{ pl: 3, mb: 4 }}>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 2 }}>
                  <strong>Log in to your account</strong> - Make sure you are logged into the application
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 2 }}>
                  <strong>Navigate to your profile settings</strong> - Go to your account settings or profile page
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 2 }}>
                  <strong>Look for the "Delete Account" button</strong> - This button is typically located in the account settings or profile section
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 2 }}>
                  <strong>Click the "Delete Account" button</strong> - This will initiate the account deletion process
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 2 }}>
                  <strong>Confirm the deletion</strong> - You will be asked to confirm your decision to delete your account
                </Typography>
              </Box>

              <Typography variant="h5" gutterBottom sx={{ color: "#d32f2f", mb: 2 }}>
                What Happens When You Delete Your Account?
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: "1.8", mb: 2 }}>
                When you delete your account:
              </Typography>
              <Box component="ul" sx={{ pl: 3, mb: 4 }}>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  All your personal data will be permanently removed from our systems
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  You will lose access to all your account information and history
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  Any saved preferences or settings will be deleted
                </Typography>
                <Typography component="li" variant="body1" sx={{ lineHeight: "1.8", mb: 1 }}>
                  This action cannot be undone or reversed
                </Typography>
              </Box>

              <Typography variant="body2" sx={{ color: "#666", fontStyle: "italic" }}>
                Thank you for using our services. We're sorry to see you go!
              </Typography>
            </Paper>
          </Box>
        </Container>
      </section>

      <FrontendFooter />
    </div>
  );
};

export default DeleteAccount; 